import gsap from 'gsap';

const initTalentFilter = (filter) => {
    const filterButtons = filter.querySelectorAll('button');
    const grid = document.querySelector('.js-talent-list')
    const cards = grid.querySelectorAll('.js-talent-card');
    const empty = grid.querySelector('.js-talent-empty');
    const reset = grid.querySelector('.js-talent-empty button');
    const search = filter.querySelector('input');
    
    if(filterButtons && filterButtons.length > 0 && cards && cards.length > 0) {

        const showAll = () => {
            cards.forEach(card => {
                card.classList.remove('hidden');
                gsap.set(card.querySelector('img'), { autoAlpha: 0})
                gsap.to(card.querySelector('img'), { autoAlpha: 1, duration: .75, ease: 'power3.inOut'})
            })
        }

        const clearFilters = () => {
            filterButtons.forEach(button => {
                if(button.dataset.term == 'all') {
                    button.classList.add('is-active');
                } else {
                    button.classList.remove('is-active');
                }
            })
            showAll();
        }

        const toggleFilters = (term) => {
            filterButtons.forEach(button => {
                if(button.dataset.term == term) {
                    button.classList.add('is-active');
                } else {
                    button.classList.remove('is-active');
                }
            })
            search.value = '';
        }

        const filterCards = (button) => {
            let filterTerm = button.dataset.term;

            if(filterTerm == 'all') {
                showAll();
            } else {
                cards.forEach(card => {
                    if(card.dataset.types.includes(filterTerm)) {
                        card.classList.remove('hidden');
                        gsap.set(card.querySelector('img'), { autoAlpha: 0})
                        gsap.to(card.querySelector('img'), { autoAlpha: 1, duration: .75, ease: 'power3.inOut'})
                    } else {
                        card.classList.add('hidden');
                    }
                })
            }
            
            toggleFilters(filterTerm);
        }

        const handleSearch = (term) => {
            let matchedCards = false;
            cards.forEach(card => {
                let cardTitle = card.querySelector('h2').textContent.toLowerCase();
                if(cardTitle.includes(term)) {
                    card.classList.remove('hidden');
                    matchedCards = true;
                    gsap.set(card.querySelector('img'), { autoAlpha: 0})
                    gsap.to(card.querySelector('img'), { autoAlpha: 1, duration: .75, ease: 'power3.inOut'})
                } else {
                    card.classList.add('hidden');
                }
            })

            if(!matchedCards) {
                empty.classList.remove('hidden');
            } else {
                empty.classList.add('hidden');
            }
        }

        filterButtons.forEach(button => {
            button.addEventListener('click', () => {
                filterCards(button);
            })
        })

        search.addEventListener('keyup', () => {
            clearFilters();
            if(search.value == '') {
                showAll();
            }
            handleSearch(search.value.toLowerCase());
        })

        reset.addEventListener('click', () => {
            search.value = '';
            empty.classList.add('hidden');
            clearFilters();
            showAll();
        })
    }
}

export default initTalentFilter;